<template>
  <v-autocomplete
    outlined
    label="Método de pagamento"
    v-bind="$attrs"
    :dense="dense"
    v-on="$listeners"
    :items="paymentsMethod"
    :item-text="itemText"
    :item-value="itemValue"
  >
    <template v-slot:selection="{ item, index, items }">
      <template v-if="index < 3">
        <v-chip class="ma-1" small>
          {{ item.name }}
        </v-chip>
      </template>

      <template v-if="index === 3">
        <span class="grey--text text-caption ml-2">
          (+{{ $attrs.value.length - 3 }} outros)
        </span>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    itemText: {
      default() {
        return (val) => `${val.code} - ${val.name}`;
      },
    },

    itemValue: {
      default() {
        return (val) => val;
      },
    },

    dense: {
      default: false,
    },
  },

  data: () => ({
    paymentsMethod: [
      { code: "cash", name: "Dinheiro" },
      { code: "credit_card", name: "Cartão de Crédito" },
      { code: "debit_card", name: "Cartão de Débito" },
      { code: "check", name: "Cheque" },
      { code: "bill", name: "Boleto" },
    ],
  }),

  created() {
    this.select();
  },

  methods: {
    select() {},
  },
};
</script>
